import { gql } from '@apollo/client';

export default gql`
  query getVoucherAlias($voucherCodeLastChars: String!, $bookingReference: String!) {
    getVoucherAliasByLastCharsAndBookingReference(voucherCodeLastChars: $voucherCodeLastChars, bookingReference: $bookingReference)
  }
`;
